import { css } from "styled-components";
import themeVariables from "../themeVariables";
const dxIconSelector = (pseudo) => `> .dx-button-content > .dx-icon:not([class*=" icon-"])${pseudo ? ":before" : ""}`;
const icomoonIconSelector = (pseudo) => `> .dx-button-content > i[class^="icon-"]${pseudo ? ":before" : ""}, > .dx-button-content > i[class*=" icon-"]${pseudo ? ":before" : ""}`;
export const btnStyles = css `
  display: inline-block;
  margin-bottom: 0;
  font-weight: ${themeVariables["btn-font-weight"]};
  font-family: ${themeVariables["font-family-base"]};
  font-size: ${themeVariables["font-size-base"]};
  font-weight: 400;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  background-image: none;
  border: 1px solid transparent;
  white-space: nowrap;
  line-height: ${themeVariables["line-height-base"]};
  border-radius: ${themeVariables["btn-border-radius"]};
  user-select: none;
  min-width: auto;
  padding: ${themeVariables["btn-padding"]};

  &.btn-with-icon {
    padding: ${themeVariables["btn-with-icon-padding"]};
  }

  > .dx-button-content {
    padding: 0;
  }

  overflow: visible !important;
  &.overflow-hidden > .dx-button-content {
    overflow: hidden;
  }

  &:not(.dropdown-toggle) {
    box-shadow: ${themeVariables["btn-shadow"]};
  }
  &.dropdown-toggle {
    box-shadow: ${themeVariables["input-shadow"]};
  }

  &.no-pointer-states {
    cursor: default;

    &.dx-state-active {
      outline: 0;
      background-image: none;
      box-shadow: none;
      background-color: ${themeVariables["btn-default-bg"]};
      border-color: ${themeVariables["btn-default-border"]};
    }
    &.dx-state-disabled {
      cursor: not-allowed;
      pointer-events: none;
      opacity: 0.4;
      box-shadow: none;
    }
  }

  &:not(.no-pointer-states) {
    &:hover,
    &:focus {
      color: ${themeVariables["btn-default-color"]};
      text-decoration: none;
    }

    &:active,
    &.active,
    &.dx-state-active {
      outline: 0;
      background-image: none;
      box-shadow: ${themeVariables["btn-default-shadow-active"]};
      background-color: ${themeVariables["btn-default-bg"]};
      border-color: ${themeVariables["btn-default-border"]};
    }
    &.disabled,
    &[disabled],
    &.dx-state-disabled {
      cursor: not-allowed;
      pointer-events: none;
      opacity: 0.4;
      box-shadow: none;
    }
  }
`;
const buttonVariantStates = (hover, active, disabled) => css `
  &:not(.no-pointer-states) {
    &:hover,
    &:focus,
    &.dx-state-hover {
      color: ${themeVariables[hover.color]};
      background-color: ${themeVariables[hover.bg]};
      border-color: ${themeVariables[hover.border]};

      ${hover.additionalCss}
      ${dxIconSelector(false)},
      ${icomoonIconSelector(false)} {
        color: ${hover.iconColor ? themeVariables[hover.iconColor] : themeVariables[hover.color]};
      }
    }

    &:active,
    &.active,
    &.dx-state-active,
    .open .dropdown-toggle& {
      color: ${themeVariables[active.color]};
      background-color: ${themeVariables[active.bg]};
      border-color: ${themeVariables[active.border]};
      opacity: 1;
      ${active.additionalCss}

      ${dxIconSelector(false)},
      ${icomoonIconSelector(false)} {
        color: ${active.iconColor
    ? themeVariables[active.iconColor]
    : themeVariables[active.color]};
      }
    }

    &.disabled,
    &[disabled],
    &.dx-state-disabled {
      &,
      &:hover,
      &:focus,
      &:active,
      &.active {
        color: ${themeVariables[disabled.color]};
        background-color: ${themeVariables[disabled.bg]};
        border-color: ${themeVariables[disabled.border]};
        ${disabled.additionalCss}

        color: ${themeVariables[disabled.color]};
        opacity: 1;

        ${dxIconSelector(false)},
        ${icomoonIconSelector(false)} {
          color: ${disabled.iconColor
    ? themeVariables[disabled.iconColor]
    : themeVariables[disabled.color]};
        }
      }
    }
  }
`;
const buttonVariant = (color, bg, border, iconColor, hover, active, disabled) => css `
  ${dxIconSelector(true)},
  ${icomoonIconSelector(true)} {
    color: inherit;
    opacity: inherit;
  }

  &:not(.no-default-colors) {
    color: ${themeVariables[color]};
    background-color: ${themeVariables[bg]};
    border-color: ${themeVariables[border]};

    ${dxIconSelector(false)},
    ${icomoonIconSelector(false)} {
      color: ${iconColor ? themeVariables[iconColor] : themeVariables[color]};
    }

    ${buttonVariantStates(hover, active, disabled)}
  }

  &.no-default-colors {
    &,
    &:hover,
    &:focus,
    &.dx-state-hover,
    &:active,
    &.active,
    &.dx-state-active,
    .open .dropdown-toggle& {
      color: inherit;
      background-color: transparent;
      border-color: transparent;
    }
  }

  ${dxIconSelector(false)},
  ${icomoonIconSelector(false)} {
    vertical-align: bottom;
    display: inline;
  }
  ${dxIconSelector(false)} {
    line-height: ${themeVariables["font-size-base"]};
    height: auto;
  }

  ${icomoonIconSelector(false)} {
    line-height: ${themeVariables["font-size-h5"]};
  }

  ${dxIconSelector(false)} {
    &:not([class*=" font-h"]):before {
      font-size: ${themeVariables["font-size-base"]};
    }
  }

  ${icomoonIconSelector(false)} {
    &:not([class*=" font-h"]):before {
      font-size: ${themeVariables["font-size-h5"]};
    }
  }
`;
export const btnDefaultStyles = buttonVariant("btn-default-color", "btn-default-bg", "btn-default-border", undefined, {
    color: "btn-default-color-hover",
    bg: "btn-default-bg-hover",
    border: "btn-default-border-hover"
}, {
    color: "btn-default-color-active",
    bg: "btn-default-bg-active",
    border: "btn-default-border-active"
}, {
    color: "btn-default-color-disabled",
    bg: "btn-default-bg-disabled",
    border: "btn-default-border-disabled"
});
export const btnPrimaryStyles = buttonVariant("btn-primary-color", "btn-primary-bg", "btn-primary-border", undefined, {
    color: "btn-primary-color-hover",
    bg: "btn-primary-bg-hover",
    border: "btn-primary-border-hover",
    additionalCss: `box-shadow: ${themeVariables["btn-primary-shadow-hover"]};`
}, {
    color: "btn-primary-color-active",
    bg: "btn-primary-bg-active",
    border: "btn-primary-border-active"
}, {
    color: "btn-primary-color-disabled",
    bg: "btn-primary-bg-disabled",
    border: "btn-primary-border-disabled"
});
export const btnDarkStyles = buttonVariant("btn-dark-color", "btn-dark-bg", "btn-dark-border", "btn-dark-icon-color", {
    color: "btn-dark-color-hover",
    bg: "btn-dark-bg-hover",
    border: "btn-dark-border-hover"
}, {
    color: "btn-dark-color-active",
    bg: "btn-dark-bg-active",
    border: "btn-dark-border-active"
}, {
    color: "btn-dark-color-disabled",
    bg: "btn-dark-bg-disabled",
    border: "btn-dark-border-disabled",
    iconColor: "btn-dark-icon-color-disabled"
});
export const btnPrimaryDarkStyles = buttonVariant("btn-primary-dark-color", "btn-primary-dark-bg", "btn-primary-dark-border", "btn-primary-dark-icon-color", {
    color: "btn-primary-dark-color-hover",
    bg: "btn-primary-dark-bg-hover",
    border: "btn-primary-dark-border-hover",
    additionalCss: `box-shadow: ${themeVariables["btn-primary-dark-shadow-hover"]};`
}, {
    color: "btn-primary-dark-color-active",
    bg: "btn-primary-dark-bg-active",
    border: "btn-primary-dark-border-active"
}, {
    color: "btn-primary-dark-color-disabled",
    bg: "btn-primary-dark-bg-disabled",
    border: "btn-primary-dark-border-disabled",
    iconColor: "btn-primary-dark-icon-color-disabled"
});
export const btnTextStyles = buttonVariant("btn-text-color", "btn-text-bg", "btn-text-border", "btn-text-icon-color", {
    color: "btn-text-color-hover",
    iconColor: "btn-text-icon-color-hover",
    bg: "btn-text-bg-hover",
    border: "btn-text-border-hover"
}, {
    color: "btn-text-color-active",
    iconColor: "btn-text-icon-color-active",
    bg: "btn-text-bg-active",
    border: "btn-text-border-active"
}, {
    color: "btn-text-color-disabled",
    iconColor: "btn-text-icon-color-disabled",
    bg: "btn-text-bg-disabled",
    border: "btn-text-border-disabled"
});
export const btnTextRedStyles = buttonVariant("btn-text-red-color", "btn-text-red-bg", "btn-text-red-border", "btn-text-red-icon-color", {
    color: "btn-text-red-color-hover",
    iconColor: "btn-text-red-icon-color-hover",
    bg: "btn-text-red-bg-hover",
    border: "btn-text-red-border-hover"
}, {
    color: "btn-text-red-color-active",
    iconColor: "btn-text-red-icon-color-active",
    bg: "btn-text-red-bg-active",
    border: "btn-text-red-border-active"
}, {
    color: "btn-text-red-color-disabled",
    iconColor: "btn-text-red-icon-color-disabled",
    bg: "btn-text-red-bg-disabled",
    border: "btn-text-red-border-disabled"
});
export const btnArrowActionStyles = buttonVariant("btn-arrow-action-color", "btn-arrow-action-bg", "btn-arrow-action-border", "btn-arrow-action-icon-color", {
    color: "btn-arrow-action-color-hover",
    iconColor: "btn-arrow-action-icon-color-hover",
    bg: "btn-arrow-action-bg-hover",
    border: "btn-arrow-action-border-hover"
}, {
    color: "btn-arrow-action-color-active",
    iconColor: "btn-arrow-action-icon-color-active",
    bg: "btn-arrow-action-bg-active",
    border: "btn-arrow-action-border-active"
}, {
    color: "btn-arrow-action-color-disabled",
    iconColor: "btn-arrow-action-icon-color-disabled",
    bg: "btn-arrow-action-bg-disabled",
    border: "btn-arrow-action-border-disabled"
});
export const btnFilledStyles = buttonVariant("btn-filled-color", "btn-filled-bg", "btn-filled-border", "btn-filled-icon-color", {
    color: "btn-filled-color-hover",
    iconColor: "btn-filled-icon-color-hover",
    bg: "btn-filled-bg-hover",
    border: "btn-filled-border-hover"
}, {
    color: "btn-filled-color-active",
    iconColor: "btn-filled-icon-color-active",
    bg: "btn-filled-bg-active",
    border: "btn-filled-border-active"
}, {
    color: "btn-filled-color-disabled",
    iconColor: "btn-filled-icon-color-disabled",
    bg: "btn-filled-bg-disabled",
    border: "btn-filled-border-disabled"
});
export const btnDeleteRedStyles = buttonVariant("btn-delete-red-color", "btn-delete-red-bg", "btn-delete-red-border", "btn-delete-red-icon-color", {
    color: "btn-delete-red-color-hover",
    iconColor: "btn-delete-red-icon-color-hover",
    bg: "btn-delete-red-bg-hover",
    border: "btn-delete-red-border-hover"
}, {
    color: "btn-delete-red-color-active",
    iconColor: "btn-delete-red-icon-color-active",
    bg: "btn-delete-red-bg-active",
    border: "btn-delete-red-border-active"
}, {
    color: "btn-delete-red-color-disabled",
    iconColor: "btn-delete-red-icon-color-disabled",
    bg: "btn-delete-red-bg-disabled",
    border: "btn-delete-red-border-disabled"
});
